module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_china.d49f1dc1.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/digitalCamouflageDesert/DIGITAL_CAMOUFLAGE_DESERT_china.png
// module id = 1217
// module chunks = 16